import NiceModal, {useModal} from '@ebay/nice-modal-react';

import {useI18n} from '@yourcoach/i18n';

import ModalNew from '../../../components/ModalNew';
import AddCard from '../../../modules/payments/AddCard';

export const AddCardModal = NiceModal.create(() => {
  const {t} = useI18n();
  const modal = useModal();

  return (
    <ModalNew
      bodyClassName="body"
      isOpen={modal.visible}
      onAfterClose={modal.remove}
      onRequestClose={modal.hide}
      title={t('shared:add_card_label')}
    >
      <AddCard />
    </ModalNew>
  );
});
